import React from 'react';
import styled from 'styled-components';
import { CheckboxOld, RadioGroup } from 'shared/components';
import { GqlImageBannerPlatform } from 'types/graphql';

import { Title, Body, Input, InputContainer, ValidateCheckIcon } from './image-banner-modal.styles';
import { validateURL } from './image-banner-modal.helper';

type ImageBannerPlatformProps = {
  description: string | null | undefined;
  label: string;
  linkBehaviorDescription?: string;
  platform: GqlImageBannerPlatform;
  setPlatform: (platform: GqlImageBannerPlatform) => void;
};

export default function ImageBannerPlatform({
  description,
  label,
  linkBehaviorDescription,
  platform,
  setPlatform,
}: ImageBannerPlatformProps): JSX.Element {
  return (
    <PlatformCard>
      <header>
        <CheckboxOld
          checked={platform.enabled}
          id={platform.type}
          label={label}
          name={platform.type}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            setPlatform({ ...platform, enabled: e.target.checked });
          }}
          pt='11px'
          width='100%'
        />
      </header>

      {platform.enabled && (
        <>
          {description && (
            <Body>
              <Description>{description}</Description>
            </Body>
          )}
          <InputBuffer>
            <InputContainer>
              <Input
                type='url'
                value={platform.link ?? ''}
                onChange={(event) => setPlatform({ ...platform, link: event.target.value })}
                placeholder='Type or paste URL'
              />
              <ValidateCheckIcon valid={validateURL(platform.link ?? '') ? 1 : 0} />
            </InputContainer>
          </InputBuffer>

          <Title>Link Behavior</Title>

          {linkBehaviorDescription ? (
            <Body>
              <Description>{linkBehaviorDescription}</Description>
            </Body>
          ) : (
            <RadioGroup
              fontSize='13px'
              mb='0px'
              options={[
                {
                  label: 'Open in New Tab',
                  value: true,
                },
                {
                  label: 'Open in Current Tab',
                  value: false,
                },
              ]}
              display={['inline-block']}
              defaultValue={platform.openInNewTab}
              onChange={(value: boolean) => setPlatform({ ...platform, openInNewTab: value })}
            />
          )}
        </>
      )}
    </PlatformCard>
  );
}
const PlatformCard = styled.div`
  background: #ffffff;
  border-radius: 6px;
  border: 1px solid #d3d8de;
  box-shadow: 0px 3px 5px #e9ecf1;
  margin-bottom: 20px;
  width: 100%;
  padding: 19px 20px;

  header {
    align-items: center;
    display: flex;
    justify-content: space-between;

    label {
      color: #4f5d68;
      font-size: 14px;
      font-weight: bold;
      padding-top: 0;
    }
  }
`;

const Description = styled.div`
  margin-top: 10px;
`;

const InputBuffer = styled.div`
  margin-bottom: 10px;
`;
